var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ve-line',{attrs:{"data":_vm.dataset,"height":_vm.height,"data-empty":_vm.empty,"loading":_vm.loading,"toolbox":_vm.toolbox}})}
var staticRenderFns = []

export { render, staticRenderFns }